import React from "react";
import ReadyForPickup from "../../admin/ReadyForPickup/ReadyForPickup";
import usePageName from "../../../hocs/usePageName";
import { useSearchParams } from "react-router-dom";
import { Container } from "@mui/material";

const ReadyForPickupPage = () => {
  usePageName({
    heading: "Ready For Pickup",
    caption: null,
  });
  const [searchParams, setSearchParams] = useSearchParams();
  let search = searchParams.get("search");
  let status = searchParams.get("status");
  return (
    <Container>
      <ReadyForPickup
        search={search}
        includePaymentInfo={false}
        status={status ?? "PENDING"}
      />
    </Container>
  );
};

export default ReadyForPickupPage;
